"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _defaults = _interopRequireDefault(require("defaults"));

var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));

var _TerminalMessage = _interopRequireDefault(require("./TerminalMessage"));

var _validateCommands2 = _interopRequireDefault(require("./handlers/validateCommands"));

var _scrollHistory2 = _interopRequireDefault(require("./handlers/scrollHistory"));

var _Terminal = _interopRequireDefault(require("./defs/styles/Terminal"));

var _Terminal2 = _interopRequireDefault(require("./defs/types/Terminal")); // Components
// Handlers
// Definitions


var Terminal =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Terminal, _Component);

  function Terminal(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Terminal);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Terminal).call(this, props));
    _this.state = {
      commands: {},
      stdout: [],
      history: [],
      historyPosition: null,
      previousHistoryPosition: null,
      processing: false
    };
    _this.terminalRoot = _react["default"].createRef();
    _this.terminalInput = _react["default"].createRef();
    _this.focusTerminal = _this.focusTerminal.bind((0, _assertThisInitialized2["default"])(_this));
    _this.validateCommands = _this.validateCommands.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showWelcomeMessage = _this.showWelcomeMessage.bind((0, _assertThisInitialized2["default"])(_this));
    _this.showHelp = _this.showHelp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.pushToStdout = _this.pushToStdout.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getStdout = _this.getStdout.bind((0, _assertThisInitialized2["default"])(_this));
    _this.clearStdout = _this.clearStdout.bind((0, _assertThisInitialized2["default"])(_this));
    _this.processCommand = _this.processCommand.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInput = _this.handleInput.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Terminal, [{
    key: "focusTerminal",

    /* istanbul ignore next: Covered by interactivity tests */
    value: function focusTerminal() {
      // Only focus the terminal if text isn't being copied
      var isTextSelected = window.getSelection().type === 'Range';
      if (!isTextSelected) this.terminalInput.current.focus();
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "scrollToBottom",
    value: function scrollToBottom() {
      var rootNode = this.terminalRoot.current; // This may look ridiculous, but it is necessary to decouple execution for just a millisecond in order to scroll all the way

      setTimeout(function () {
        rootNode.scrollTop = rootNode.scrollHeight;
      }, 1);
    }
  }, {
    key: "validateCommands",
    value: function validateCommands() {
      var validCommands = (0, _validateCommands2["default"])(this.props.commands, this.showHelp, this.clearStdout, this.props.noDefaults);
      this.setState({
        commands: validCommands
      });
    }
  }, {
    key: "showWelcomeMessage",
    value: function showWelcomeMessage() {
      var _this2 = this;

      var msg = this.props.welcomeMessage;
      if (typeof msg === 'boolean') this.pushToStdout('Welcome to the React terminal! Type \'help\' to get a list of commands.');else if (Array.isArray(msg)) msg.map(function (item) {
        return _this2.pushToStdout(item);
      });else this.pushToStdout(msg);
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "showHelp",
    value: function showHelp() {
      var commands = this.state.commands;

      for (var c in commands) {
        var cmdObj = commands[c];
        var usage = cmdObj.usage ? " - ".concat(cmdObj.usage) : '';
        this.pushToStdout("".concat(c, " - ").concat(cmdObj.description).concat(usage));
      }
    }
  }, {
    key: "pushToStdout",
    value: function pushToStdout(message, rawInput) {
      var _this$state = this.state,
          stdout = _this$state.stdout,
          history = _this$state.history;
      stdout.push(message);
      /* istanbul ignore if: Covered by interactivity tests */

      if (rawInput) {
        // Only supplied if history is enabled
        history.push(rawInput);
        this.setState({
          stdout: stdout,
          history: history,
          historyPosition: null
        });
      } else {
        this.setState({
          stdout: stdout
        });
      }
    }
  }, {
    key: "getStdout",
    value: function getStdout() {
      return this.state.stdout.map(function (line, i) {
        return _react["default"].createElement(_TerminalMessage["default"], {
          key: i,
          content: line
        });
      });
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "clearStdout",
    value: function clearStdout() {
      this.setState({
        stdout: []
      });
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "clearInput",
    value: function clearInput() {
      this.setState({
        historyPosition: null
      });
      this.terminalInput.current.value = '';
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "processCommand",
    value: function processCommand() {
      var _this3 = this;

      this.setState({
        processing: true
      }, function () {
        // Initialise command result object
        var commandResult = {
          command: null,
          args: [],
          rawInput: null,
          result: null
        };
        var rawInput = _this3.terminalInput.current.value;

        if (!_this3.props.noAutomaticStdout) {
          if (!_this3.props.noHistory) _this3.pushToStdout("".concat(_this3.props.promptLabel || '$', " ").concat(rawInput), rawInput);else _this3.pushToStdout("".concat(_this3.props.promptLabel || '$', " ").concat(rawInput));
        }

        if (rawInput) {
          var input = rawInput.split(' ');
          var command = input.splice(0, 1)[0]; // Removed portion is returned...

          var args = input; // ...and the rest can be used

          commandResult.rawInput = rawInput;
          commandResult.command = command;
          commandResult.args = args;
          var cmdObj = _this3.state.commands[command];
          if (!cmdObj) _this3.pushToStdout(_this3.props.errorText ? _this3.props.errorText.replace(/\[command\]/gi, command) : "Command '".concat(command, "' not found!"));else {
            var res = cmdObj.fn.apply(cmdObj, (0, _toConsumableArray2["default"])(args));

            _this3.pushToStdout(res);

            commandResult.result = res;
            if (cmdObj.explicitExec) cmdObj.fn.apply(cmdObj, (0, _toConsumableArray2["default"])(args));
          }
        }

        _this3.setState({
          processing: false
        }, function () {
          _this3.clearInput();

          if (!_this3.props.noAutoScroll) _this3.scrollToBottom();
          if (_this3.props.commandCallback) _this3.props.commandCallback(commandResult);
        });
      });
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "scrollHistory",
    value: function scrollHistory(direction) {
      var toUpdate = (0, _scrollHistory2["default"])(direction, this.state.history, this.state.historyPosition, this.state.previousHistoryPosition, this.terminalInput, this.props.noAutomaticStdout);
      this.setState(toUpdate);
    }
    /* istanbul ignore next: Covered by interactivity tests */

  }, {
    key: "handleInput",
    value: function handleInput(event) {
      switch (event.key) {
        case 'Enter':
          this.processCommand();
          break;

        case 'ArrowUp':
          this.scrollHistory('up');
          break;

        case 'ArrowDown':
          this.scrollHistory('down');
          break;
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If there was a change in commands, re-validate
      if (!(0, _reactFastCompare["default"])(prevProps.commands, this.props.commands)) this.validateCommands();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.validateCommands();
      if (this.props.welcomeMessage) this.showWelcomeMessage();
      /* istanbul ignore next: Covered by interactivity tests */

      if (this.props.autoFocus) this.focusTerminal();
    }
  }, {
    key: "render",
    value: function render() {
      var styles = {
        container: (0, _defaults["default"])(this.props.style, _Terminal["default"].container),
        content: (0, _defaults["default"])(this.props.contentStyle, _Terminal["default"].content),
        inputArea: (0, _defaults["default"])(this.props.inputAreaStyle, _Terminal["default"].inputArea),
        promptLabel: (0, _defaults["default"])(this.props.promptLabelStyle, _Terminal["default"].promptLabel),
        input: (0, _defaults["default"])(this.props.inputStyle, _Terminal["default"].input)
      };
      return _react["default"].createElement("div", {
        ref: this.terminalRoot,
        name: 'react-console-emulator',
        className: this.props.className,
        style: styles.container,
        onClick: this.focusTerminal
      }, _react["default"].createElement("div", {
        name: 'react-console-emulator__content',
        className: this.props.contentClassName,
        style: styles.content
      }, this.getStdout(), _react["default"].createElement("div", {
        name: 'react-console-emulator__inputArea',
        className: this.props.inputAreaClassName,
        style: styles.inputArea
      }, _react["default"].createElement("span", {
        name: 'react-console-emulator__promptLabel',
        className: this.props.promptLabelClassName,
        style: styles.promptLabel
      }, this.props.promptLabel || '$'), _react["default"].createElement("input", {
        ref: this.terminalInput,
        name: 'react-console-emulator__input',
        className: this.props.inputClassName,
        style: styles.input,
        onKeyDown: this.handleInput,
        type: 'text',
        autoComplete: 'off',
        disabled: this.props.disableOnProcess &&
        /* istanbul ignore next: Covered by interactivity tests */
        this.state.processing
      }))));
    }
  }]);
  return Terminal;
}(_react.Component);

exports["default"] = Terminal;
(0, _defineProperty2["default"])(Terminal, "propTypes", _Terminal2["default"]);